// Pot economics shared by the Rush Mid UI.

// Entry tickets — a match is only made between players holding the same ticket.
export const TICKETS = [100, 500, 1000, 5000, 25000, 100000];
export const DEFAULT_TICKET = TICKETS[0];

/** Payout the backend sends per player (the UI only displays it). Shared type. */
export type { RushMidPayout as Payout } from '@cs-shot/battle-sim';
